import { useQuery } from "@tanstack/react-query";
import UserService from "../services/User/UserService";

export const useTimezones = () => {
    return useQuery({
        queryKey: ["timezones"],
        queryFn: () => UserService.getTimezones().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        placeholderData: (prevData) => prevData
    });
};